import React from 'react';

interface TooltipIconProps {
  color?: string;
}

const TooltipDefaultIcon: React.FC<TooltipIconProps> = ({
  color = '#8BBC07',
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6665 22C18.1894 22 22.6665 17.5228 22.6665 12C22.6665 6.47715 18.1894 2 12.6665 2C7.14366 2 2.6665 6.47715 2.6665 12C2.6665 17.5228 7.14366 22 12.6665 22Z"
        fill={color}
      />
      <path
        d="M12.6665 16V12"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12.6665" cy="8" r="1" fill="white" />
    </svg>
  );
};

export default TooltipDefaultIcon;
